// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { AcceptInviteAsUserData, AcceptInviteAsUserResponses, ActivateRepositoryWritesForAWorkspaceIfAbsentAsUserData, ActivateRepositoryWritesForAWorkspaceIfAbsentAsUserResponses, ActivateRepositoryWritesOrganizationWideAfterReviewAsUserData, ActivateRepositoryWritesOrganizationWideAfterReviewAsUserResponses, ArchiveAChannelEnvironmentAsUserData, ArchiveAChannelEnvironmentAsUserResponses, AssignKeystoreEntryAsAdminData, AssignKeystoreEntryAsAdminResponses, AttachAChannelEnvironmentAsUserData, AttachAChannelEnvironmentAsUserResponses, AttachARepositoryToAChannelEnvironmentAsUserData, AttachARepositoryToAChannelEnvironmentAsUserResponses, AttestThatAnEnrolledSandboxHostIsPermanentlyGoneAsAdminData, AttestThatAnEnrolledSandboxHostIsPermanentlyGoneAsAdminResponses, CancelTasksAsUserData, CancelTasksAsUserResponses, CancelTeamsOutboxMessageAsAdminData, CancelTeamsOutboxMessageAsAdminResponses, ChangeAChannelEnvironmentRepositoryBranchAsUserData, ChangeAChannelEnvironmentRepositoryBranchAsUserResponses, CreateANewRepositoryChatConversationAsUserData, CreateANewRepositoryChatConversationAsUserResponses, CreateARepositoryChatMessageAsUserData, CreateARepositoryChatMessageAsUserResponses, CreateBillingPortalSessionAsUserData, CreateBillingPortalSessionAsUserResponses, CreateChannelAsUserData, CreateChannelAsUserResponses, CreateIndexingRunAsUserData, CreateIndexingRunAsUserResponses, CreateIssueIntegrationProjectAsUserData, CreateIssueIntegrationProjectAsUserResponses, CreateKeystoreEntryAsAdminData, CreateKeystoreEntryAsAdminResponses, CreateMcpAccessTokenAsUserData, CreateMcpAccessTokenAsUserResponses, CreateOrganizationAsUserData, CreateOrganizationAsUserResponses, CreateSourceControlCredentialAsUserData, CreateSourceControlCredentialAsUserResponses, CreateSourceControlProviderAsUserData, CreateSourceControlProviderAsUserResponses, CreateTopupSessionAsUserData, CreateTopupSessionAsUserResponses, DecideADependencyRestoreRequestAsUserData, DecideADependencyRestoreRequestAsUserResponses, DeclineInviteAsUserData, DeclineInviteAsUserResponses, DeleteAChannelEnvironmentAsUserData, DeleteAChannelEnvironmentAsUserResponses, DeleteKeystoreEntryAsAdminData, DeleteKeystoreEntryAsAdminResponses, DeleteRepositoryAsUserData, DeleteRepositoryAsUserResponses, DeleteSourceControlCredentialAsUserData, DeleteSourceControlCredentialAsUserResponses, DeleteSourceControlWebhookAsUserData, DeleteSourceControlWebhookAsUserResponses, DetachARepositoryFromAChannelEnvironmentAsUserData, DetachARepositoryFromAChannelEnvironmentAsUserResponses, DiscoverRemoteBranchesAsUserData, DiscoverRemoteBranchesAsUserResponses, DiscoverRemoteIssueProjectsAsUserData, DiscoverRemoteIssueProjectsAsUserResponses, DiscoverRemoteRepositoriesAsUserData, DiscoverRemoteRepositoriesAsUserResponses, DownloadAnImmutableSkillFileOrExportUsingAFiveMinuteSignedCapabilityAsPublicData, DownloadAnImmutableSkillFileOrExportUsingAFiveMinuteSignedCapabilityAsPublicResponses, DownloadCompileRecordingArtifactAsUserData, DownloadCompileRecordingArtifactAsUserResponses, DownloadTelemetryPromptAsUserData, DownloadTelemetryPromptAsUserResponses, DownloadTelemetrySchemaAsUserData, DownloadTelemetrySchemaAsUserResponses, EnableOrDisablePushForARepositoryAttachmentAsUserData, EnableOrDisablePushForARepositoryAttachmentAsUserResponses, EnrollASandboxHostBindingAsAdminData, EnrollASandboxHostBindingAsAdminResponses, ExchangeMcpOauthTokenAsData, ExchangeMcpOauthTokenAsResponses, ExportSchemaTelemetryAsUserData, ExportSchemaTelemetryAsUserResponses, GenerateJiraLinkCodeAsUserData, GenerateJiraLinkCodeAsUserResponses, GetAdminOverviewAsAdminData, GetAdminOverviewAsAdminResponses, GetARepositoryChatConversationAsUserData, GetARepositoryChatConversationAsUserResponses, GetAuthorizeData, GetAuthorizeResponses, GetAuthSessionAsPublicData, GetAuthSessionAsPublicResponses, GetBillingBalanceAsUserData, GetBillingBalanceAsUserResponses, GetDashboardOverviewAsUserData, GetDashboardOverviewAsUserResponses, GetFailedRepositoriesForIndexingRunAsUserData, GetFailedRepositoriesForIndexingRunAsUserResponses, GetFlowDetailsAsUserData, GetFlowDetailsAsUserResponses, GetFlowStageJournalEntryAsUserData, GetFlowStageJournalEntryAsUserResponses, GetIndexingRunInsightsAsUserData, GetIndexingRunInsightsAsUserResponses, GetInviteByTokenAsUserData, GetInviteByTokenAsUserResponses, GetIssueDetailsAsUserData, GetIssueDetailsAsUserResponses, GetIssueIntegrationProviderDetailAsUserData, GetIssueIntegrationProviderDetailAsUserResponses, GetKeystoreSpendingAsAdminData, GetKeystoreSpendingAsAdminResponses, GetMcpOauthAuthorizationServerMetadataAsData, GetMcpOauthAuthorizationServerMetadataAsResponses, GetMcpProtectedResourceMetadataAsData, GetMcpProtectedResourceMetadataAsResponses, GetMcpProtectedResourceMetadataForArtiSkillMeshAsData, GetMcpProtectedResourceMetadataForArtiSkillMeshAsResponses, GetOrganizationAsUserData, GetOrganizationAsUserResponses, GetPlanRevisionGraphAsUserData, GetPlanRevisionGraphAsUserResponses, GetPlanRevisionTelemetryAsUserData, GetPlanRevisionTelemetryAsUserResponses, GetPlanSnapshotByIdAsUserData, GetPlanSnapshotByIdAsUserResponses, GetPlanSnapshotByIssueKeyAsUserData, GetPlanSnapshotByIssueKeyAsUserResponses, GetPlanSnapshotByStoryIssueKeyAsUserData, GetPlanSnapshotByStoryIssueKeyAsUserResponses, GetPublicPlatformStatsAsPublicData, GetPublicPlatformStatsAsPublicResponses, GetPushBrokerOverviewAsUserData, GetPushBrokerOverviewAsUserResponses, GetQuotaForecastingSummaryAsUserData, GetQuotaForecastingSummaryAsUserResponses, GetRepositoryTopologyAsUserData, GetRepositoryTopologyAsUserResponses, GetSchemaTelemetryScopeSummaryAsUserData, GetSchemaTelemetryScopeSummaryAsUserResponses, GetSourceControlProviderDetailAsUserData, GetSourceControlProviderDetailAsUserResponses, GetTaskDetailsAsUserData, GetTaskDetailsAsUserResponses, GetTaskEventsAsUserData, GetTaskEventsAsUserResponses, GetTaskFacetsAsUserData, GetTaskFacetsAsUserResponses, GetTaskLogsAsUserData, GetTaskLogsAsUserResponses, GetTeamsAdminSetupAsAdminData, GetTeamsAdminSetupAsAdminResponses, GetTeamsIntegrationStatusAsUserData, GetTeamsIntegrationStatusAsUserResponses, GetTelemetryRowByIdAsUserData, GetTelemetryRowByIdAsUserResponses, GetTimingSummaryAsUserData, GetTimingSummaryAsUserResponses, GetUsageSummaryAsUserData, GetUsageSummaryAsUserResponses, GetUserInstancesByIdChannelsByChannelIdArtifactsData, GetUserInstancesByIdChannelsByChannelIdArtifactsResponses, GetUserInstancesByIdChannelsByChannelIdMessagesData, GetUserInstancesByIdChannelsByChannelIdMessagesResponses, GetUserInstancesByIdCostData, GetUserInstancesByIdCostResponses, GetUserInstancesByIdMemoryData, GetUserInstancesByIdMemoryResponses, GetUserInstancesByIdObservabilityDiffData, GetUserInstancesByIdObservabilityDiffResponses, GetUserInstancesByIdObservabilityListData, GetUserInstancesByIdObservabilityListResponses, GetUserInstancesData, GetUserInstancesGrowthDistributionData, GetUserInstancesGrowthDistributionResponses, GetUserInstancesResponses, GithubAppInstallCallbackAsPublicData, GithubAppInstallCallbackAsPublicResponses, GrantOrganizationCreditsAsAdminData, GrantOrganizationCreditsAsAdminResponses, HandleInternalEventAsInternalData, HandleInternalEventAsInternalResponses, HandleStripeWebhookAsWebhookData, HandleStripeWebhookAsWebhookResponses, IngestMetricEntriesFromRemoteServicesAsInternalData, IngestMetricEntriesFromRemoteServicesAsInternalResponses, InspectASandboxHostBindingAndItsFenceTargetsAsAdminData, InspectASandboxHostBindingAndItsFenceTargetsAsAdminResponses, InvalidateAllSessionsForAuserAsAdminData, InvalidateAllSessionsForAuserAsAdminResponses, InvalidateOrganizationInviteAsUserData, InvalidateOrganizationInviteAsUserResponses, InviteOrganizationMemberAsUserData, InviteOrganizationMemberAsUserResponses, IssueIntegrationOauthCallbackAsUserData, IssueIntegrationOauthCallbackAsUserResponses, JoinWaitlistAsPublicData, JoinWaitlistAsPublicResponses, LaunchOrResumeAChannelWorkspaceFromAnIssueAsUserData, LaunchOrResumeAChannelWorkspaceFromAnIssueAsUserResponses, ListAgentModeBudgetsAsUserData, ListAgentModeBudgetsAsUserResponses, ListArchivedTeamsChannelsAsAdminData, ListArchivedTeamsChannelsAsAdminResponses, ListBillingTransactionsAsUserData, ListBillingTransactionsAsUserResponses, ListChannelEnvironmentRepositoryAttachmentsAsUserData, ListChannelEnvironmentRepositoryAttachmentsAsUserResponses, ListChannelsAsUserData, ListChannelsAsUserResponses, ListConnectedMcpOauthGrantsAsUserData, ListConnectedMcpOauthGrantsAsUserResponses, ListDefaultAgentModeBudgetsAsAdminData, ListDefaultAgentModeBudgetsAsAdminResponses, ListDependencyRestoreRequestsAsUserData, ListDependencyRestoreRequestsAsUserResponses, ListEnrolledSandboxHostBindingsAsAdminData, ListEnrolledSandboxHostBindingsAsAdminResponses, ListFlowLockDiagnosticsAsUserData, ListFlowLockDiagnosticsAsUserResponses, ListFlowStageJournalAsUserData, ListFlowStageJournalAsUserResponses, ListIndexingRunsAsUserData, ListIndexingRunsAsUserResponses, ListIssueIntegrationProvidersAsUserData, ListIssueIntegrationProvidersAsUserResponses, ListKeystoreEntriesAsAdminData, ListKeystoreEntriesAsAdminResponses, ListMcpAccessTokensAsUserData, ListMcpAccessTokensAsUserResponses, ListOrganizationApiKeysAsUserData, ListOrganizationApiKeysAsUserResponses, ListOrganizationFeatureFlagOverridesAsAdminData, ListOrganizationFeatureFlagOverridesAsAdminResponses, ListOrganizationInvitesAsUserData, ListOrganizationInvitesAsUserResponses, ListOrganizationMcpServersAsUserData, ListOrganizationMcpServersAsUserResponses, ListOrganizationMembersAsUserData, ListOrganizationMembersAsUserResponses, ListOrganizationsAsUserData, ListOrganizationsAsUserResponses, ListOrganizationsForAdminAsAdminData, ListOrganizationsForAdminAsAdminResponses, ListOrSearchIssuesUsingStructuredFiltersAsUserData, ListOrSearchIssuesUsingStructuredFiltersAsUserResponses, ListPendingInvitesAsUserData, ListPendingInvitesAsUserResponses, ListPlatformUsersAsAdminData, ListPlatformUsersAsAdminResponses, ListPushPoliciesForAChannelEnvironmentAsUserData, ListPushPoliciesForAChannelEnvironmentAsUserResponses, ListQuotaForecastingEntriesAsUserData, ListQuotaForecastingEntriesAsUserResponses, ListRecentPlanSnapshotsAsUserData, ListRecentPlanSnapshotsAsUserResponses, ListRepositoryChatConversationsAsUserData, ListRepositoryChatConversationsAsUserResponses, ListRetainedArtifactsForAChannelAsUserData, ListRetainedArtifactsForAChannelAsUserResponses, ListRetainedChannelArtifactVersionsAsUserData, ListRetainedChannelArtifactVersionsAsUserResponses, ListSchemaTelemetryAsUserData, ListSchemaTelemetryAsUserResponses, ListSelectableChannelEnvironmentProfilesAsUserData, ListSelectableChannelEnvironmentProfilesAsUserResponses, ListSourceControlProvidersAsUserData, ListSourceControlProvidersAsUserResponses, ListSourceControlRepositorySummariesAsUserData, ListSourceControlRepositorySummariesAsUserResponses, ListTasksAsUserData, ListTasksAsUserResponses, ListTeamsOutboxMessagesAsAdminData, ListTeamsOutboxMessagesAsAdminResponses, ListTimingEntriesAsUserData, ListTimingEntriesAsUserResponses, ListUsageEntriesAsUserData, ListUsageEntriesAsUserResponses, LogoutAsPublicData, LogoutAsPublicResponses, MintAndLaunchAChannelEnvironmentPreviewPortAsUserData, MintAndLaunchAChannelEnvironmentPreviewPortAsUserResponses, MintTeamsChannelBindingTokenAsUserData, MintTeamsChannelBindingTokenAsUserResponses, PatchAChannelEnvironmentAsUserData, PatchAChannelEnvironmentAsUserResponses, PermanentlyDeleteAnIssueWorkspaceAggregateAsUserData, PermanentlyDeleteAnIssueWorkspaceAggregateAsUserResponses, PostAuthorizeData, PostAuthorizeResponses, PostUserSourceControlChatConversationsByConversationIdMessagesStreamData, PostUserSourceControlChatConversationsByConversationIdMessagesStreamResponses, PrepareCheckpointRecoveryFromAReplacedHostAsUserData, PrepareCheckpointRecoveryFromAReplacedHostAsUserResponses, PreviewCheckpointRecoveryFromAReplacedHostAsUserData, PreviewCheckpointRecoveryFromAReplacedHostAsUserResponses, ReadAChannelEnvironmentAsUserData, ReadAChannelEnvironmentAsUserResponses, ReadARetainedChannelArtifactAsUserData, ReadARetainedChannelArtifactAsUserResponses, ReadARetainedChannelArtifactSectionAsUserData, ReadARetainedChannelArtifactSectionAsUserResponses, ReadRetainedChannelHistoryAsUserData, ReadRetainedChannelHistoryAsUserResponses, ReAuthorizeRevokedRepositoryWritesAsUserData, ReAuthorizeRevokedRepositoryWritesAsUserResponses, RefreshARepositoryAttachmentToItsRemoteBranchHeadAsUserData, RefreshARepositoryAttachmentToItsRemoteBranchHeadAsUserResponses, RegisterAnMcpOauthClientAsData, RegisterAnMcpOauthClientAsResponses, RegisterAnMcpServerForTheOrganizationAsUserData, RegisterAnMcpServerForTheOrganizationAsUserResponses, ReleaseFlowLockAsUserData, ReleaseFlowLockAsUserResponses, RemoveAnOrganizationMcpServerAsUserData, RemoveAnOrganizationMcpServerAsUserResponses, RemoveMemberAsUserData, RemoveMemberAsUserResponses, RequestOtpCodeAsPublicData, RequestOtpCodeAsPublicResponses, ReseedAgentModeBudgetsForOrganizationsAsAdminData, ReseedAgentModeBudgetsForOrganizationsAsAdminResponses, ResolveActorAttributionsAsUserData, ResolveActorAttributionsAsUserResponses, RestartAChannelEnvironmentAsUserData, RestartAChannelEnvironmentAsUserResponses, RetryAFailedExecutionFlowAsUserData, RetryAFailedExecutionFlowAsUserResponses, RetryStartingAChannelEnvironmentSSandboxAsUserData, RetryStartingAChannelEnvironmentSSandboxAsUserResponses, RetryTeamsOutboxMessageAsAdminData, RetryTeamsOutboxMessageAsAdminResponses, ReviewRepositoryWritesBeforeAnOrgWideActivationAsUserData, ReviewRepositoryWritesBeforeAnOrgWideActivationAsUserResponses, RevokeMcpAccessTokenAsUserData, RevokeMcpAccessTokenAsUserResponses, RevokeMcpOauthGrantAsUserData, RevokeMcpOauthGrantAsUserResponses, RevokeRepositoryWritesOrganizationWideAsUserData, RevokeRepositoryWritesOrganizationWideAsUserResponses, SaveTeamsAdminSetupAsAdminData, SaveTeamsAdminSetupAsAdminResponses, SelectOrganizationAsUserData, SelectOrganizationAsUserResponses, SetOrganizationFeatureFlagOverrideAsAdminData, SetOrganizationFeatureFlagOverrideAsAdminResponses, SetupGithubAppInstallationAsUserData, SetupGithubAppInstallationAsUserResponses, SetupGithubOrgWebhookAsUserData, SetupGithubOrgWebhookAsUserResponses, SetUpOrganizationBillingAsUserData, SetUpOrganizationBillingAsUserResponses, SkipTeamsOutboxMessageAsAdminData, SkipTeamsOutboxMessageAsAdminResponses, StartACompileRecordingForACompletedExecutionFlowAsUserData, StartACompileRecordingForACompletedExecutionFlowAsUserResponses, UnassignKeystoreEntryAsAdminData, UnassignKeystoreEntryAsAdminResponses, UpdateAnOrganizationMcpServerAsUserData, UpdateAnOrganizationMcpServerAsUserResponses, UpdateMemberRoleAsUserData, UpdateMemberRoleAsUserResponses, UpdateSourceControlCredentialAsUserData, UpdateSourceControlCredentialAsUserResponses, UpsertAgentModeBudgetsAsUserData, UpsertAgentModeBudgetsAsUserResponses, UpsertSourceControlRepositoriesAsUserData, UpsertSourceControlRepositoriesAsUserResponses, ValidateTeamsBotCredentialsAsAdminData, ValidateTeamsBotCredentialsAsAdminResponses, VerifyOtpCodeAsPublicData, VerifyOtpCodeAsPublicResponses, VerifySourceControlCredentialAsUserData, VerifySourceControlCredentialAsUserResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Get MCP OAuth authorization server metadata
 */
export const getMcpOauthAuthorizationServerMetadataAs = <ThrowOnError extends boolean = true>(options?: Options<GetMcpOauthAuthorizationServerMetadataAsData, ThrowOnError>) => (options?.client ?? client).get<GetMcpOauthAuthorizationServerMetadataAsResponses, unknown, ThrowOnError>({ url: '/.well-known/oauth-authorization-server', ...options });

/**
 * Get MCP protected resource metadata
 */
export const getMcpProtectedResourceMetadataAs = <ThrowOnError extends boolean = true>(options?: Options<GetMcpProtectedResourceMetadataAsData, ThrowOnError>) => (options?.client ?? client).get<GetMcpProtectedResourceMetadataAsResponses, unknown, ThrowOnError>({ url: '/.well-known/oauth-protected-resource/public/mcp', ...options });

/**
 * Get MCP protected resource metadata for Arti Skill Mesh
 */
export const getMcpProtectedResourceMetadataForArtiSkillMeshAs = <ThrowOnError extends boolean = true>(options?: Options<GetMcpProtectedResourceMetadataForArtiSkillMeshAsData, ThrowOnError>) => (options?.client ?? client).get<GetMcpProtectedResourceMetadataForArtiSkillMeshAsResponses, unknown, ThrowOnError>({ url: '/.well-known/oauth-protected-resource/public/skill-mesh/mcp', ...options });

export const getAuthorize = <ThrowOnError extends boolean = true>(options: Options<GetAuthorizeData, ThrowOnError>) => (options.client ?? client).get<GetAuthorizeResponses, unknown, ThrowOnError>({ url: '/authorize', ...options });

export const postAuthorize = <ThrowOnError extends boolean = true>(options?: Options<PostAuthorizeData, ThrowOnError>) => (options?.client ?? client).post<PostAuthorizeResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/authorize',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * Register an MCP OAuth client
 */
export const registerAnMcpOauthClientAs = <ThrowOnError extends boolean = true>(options?: Options<RegisterAnMcpOauthClientAsData, ThrowOnError>) => (options?.client ?? client).post<RegisterAnMcpOauthClientAsResponses, unknown, ThrowOnError>({
    url: '/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Exchange MCP OAuth token
 */
export const exchangeMcpOauthTokenAs = <ThrowOnError extends boolean = true>(options?: Options<ExchangeMcpOauthTokenAsData, ThrowOnError>) => (options?.client ?? client).post<ExchangeMcpOauthTokenAsResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/token',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * Get auth session
 */
export const getAuthSessionAsPublic = <ThrowOnError extends boolean = true>(options?: Options<GetAuthSessionAsPublicData, ThrowOnError>) => (options?.client ?? client).get<GetAuthSessionAsPublicResponses, unknown, ThrowOnError>({ url: '/public/auth/session', ...options });

/**
 *  Logout
 */
export const logoutAsPublic = <ThrowOnError extends boolean = true>(options?: Options<LogoutAsPublicData, ThrowOnError>) => (options?.client ?? client).post<LogoutAsPublicResponses, unknown, ThrowOnError>({ url: '/public/auth/logout', ...options });

/**
 * Request OTP code
 */
export const requestOtpCodeAsPublic = <ThrowOnError extends boolean = true>(options?: Options<RequestOtpCodeAsPublicData, ThrowOnError>) => (options?.client ?? client).post<RequestOtpCodeAsPublicResponses, unknown, ThrowOnError>({
    url: '/public/auth/otp/request',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Verify OTP code
 */
export const verifyOtpCodeAsPublic = <ThrowOnError extends boolean = true>(options?: Options<VerifyOtpCodeAsPublicData, ThrowOnError>) => (options?.client ?? client).post<VerifyOtpCodeAsPublicResponses, unknown, ThrowOnError>({
    url: '/public/auth/otp/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Download an immutable skill file or export using a five-minute signed capability
 */
export const downloadAnImmutableSkillFileOrExportUsingAFiveMinuteSignedCapabilityAsPublic = <ThrowOnError extends boolean = true>(options: Options<DownloadAnImmutableSkillFileOrExportUsingAFiveMinuteSignedCapabilityAsPublicData, ThrowOnError>) => (options.client ?? client).get<DownloadAnImmutableSkillFileOrExportUsingAFiveMinuteSignedCapabilityAsPublicResponses, unknown, ThrowOnError>({ url: '/public/skill-mesh/download', ...options });

/**
 * GitHub App install callback
 */
export const githubAppInstallCallbackAsPublic = <ThrowOnError extends boolean = true>(options?: Options<GithubAppInstallCallbackAsPublicData, ThrowOnError>) => (options?.client ?? client).get<GithubAppInstallCallbackAsPublicResponses, unknown, ThrowOnError>({ url: '/public/source-control/github/callback', ...options });

/**
 * Get public platform stats
 */
export const getPublicPlatformStatsAsPublic = <ThrowOnError extends boolean = true>(options?: Options<GetPublicPlatformStatsAsPublicData, ThrowOnError>) => (options?.client ?? client).get<GetPublicPlatformStatsAsPublicResponses, unknown, ThrowOnError>({ url: '/public/stats', ...options });

/**
 * Join waitlist
 */
export const joinWaitlistAsPublic = <ThrowOnError extends boolean = true>(options?: Options<JoinWaitlistAsPublicData, ThrowOnError>) => (options?.client ?? client).post<JoinWaitlistAsPublicResponses, unknown, ThrowOnError>({
    url: '/public/waitlist/join',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Handle internal event
 */
export const handleInternalEventAsInternal = <ThrowOnError extends boolean = true>(options?: Options<HandleInternalEventAsInternalData, ThrowOnError>) => (options?.client ?? client).post<HandleInternalEventAsInternalResponses, unknown, ThrowOnError>({
    url: '/internal/events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Ingest metric entries from remote services
 */
export const ingestMetricEntriesFromRemoteServicesAsInternal = <ThrowOnError extends boolean = true>(options?: Options<IngestMetricEntriesFromRemoteServicesAsInternalData, ThrowOnError>) => (options?.client ?? client).post<IngestMetricEntriesFromRemoteServicesAsInternalResponses, unknown, ThrowOnError>({
    url: '/internal/metrics',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * List dependency restore requests
 */
export const listDependencyRestoreRequestsAsUser = <ThrowOnError extends boolean = true>(options: Options<ListDependencyRestoreRequestsAsUserData, ThrowOnError>) => (options.client ?? client).get<ListDependencyRestoreRequestsAsUserResponses, unknown, ThrowOnError>({ url: '/user/dependency-restores', ...options });

/**
 * Decide a dependency restore request
 */
export const decideADependencyRestoreRequestAsUser = <ThrowOnError extends boolean = true>(options?: Options<DecideADependencyRestoreRequestAsUserData, ThrowOnError>) => (options?.client ?? client).post<DecideADependencyRestoreRequestAsUserResponses, unknown, ThrowOnError>({
    url: '/user/dependency-restores/decision',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Resolve actor attributions
 */
export const resolveActorAttributionsAsUser = <ThrowOnError extends boolean = true>(options?: Options<ResolveActorAttributionsAsUserData, ThrowOnError>) => (options?.client ?? client).post<ResolveActorAttributionsAsUserResponses, unknown, ThrowOnError>({
    url: '/user/actor-attributions/resolve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * List retained artifacts for a channel
 */
export const listRetainedArtifactsForAChannelAsUser = <ThrowOnError extends boolean = true>(options: Options<ListRetainedArtifactsForAChannelAsUserData, ThrowOnError>) => (options.client ?? client).get<ListRetainedArtifactsForAChannelAsUserResponses, unknown, ThrowOnError>({ url: '/user/channels/{channelId}/artifacts', ...options });

/**
 * Read a retained channel artifact
 */
export const readARetainedChannelArtifactAsUser = <ThrowOnError extends boolean = true>(options: Options<ReadARetainedChannelArtifactAsUserData, ThrowOnError>) => (options.client ?? client).get<ReadARetainedChannelArtifactAsUserResponses, unknown, ThrowOnError>({ url: '/user/channels/{channelId}/artifacts/{artifactId}', ...options });

/**
 * Read a retained channel artifact section
 */
export const readARetainedChannelArtifactSectionAsUser = <ThrowOnError extends boolean = true>(options: Options<ReadARetainedChannelArtifactSectionAsUserData, ThrowOnError>) => (options.client ?? client).get<ReadARetainedChannelArtifactSectionAsUserResponses, unknown, ThrowOnError>({ url: '/user/channels/{channelId}/artifacts/{artifactId}/sections/{sectionId}', ...options });

/**
 * List retained channel artifact versions
 */
export const listRetainedChannelArtifactVersionsAsUser = <ThrowOnError extends boolean = true>(options: Options<ListRetainedChannelArtifactVersionsAsUserData, ThrowOnError>) => (options.client ?? client).get<ListRetainedChannelArtifactVersionsAsUserResponses, unknown, ThrowOnError>({ url: '/user/channels/{channelId}/artifacts/{artifactId}/versions', ...options });

/**
 * List channels
 */
export const listChannelsAsUser = <ThrowOnError extends boolean = true>(options?: Options<ListChannelsAsUserData, ThrowOnError>) => (options?.client ?? client).get<ListChannelsAsUserResponses, unknown, ThrowOnError>({ url: '/user/channels', ...options });

/**
 * Create channel
 */
export const createChannelAsUser = <ThrowOnError extends boolean = true>(options?: Options<CreateChannelAsUserData, ThrowOnError>) => (options?.client ?? client).post<CreateChannelAsUserResponses, unknown, ThrowOnError>({
    url: '/user/channels',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Read retained channel history
 */
export const readRetainedChannelHistoryAsUser = <ThrowOnError extends boolean = true>(options: Options<ReadRetainedChannelHistoryAsUserData, ThrowOnError>) => (options.client ?? client).get<ReadRetainedChannelHistoryAsUserResponses, unknown, ThrowOnError>({ url: '/user/channels/{channelId}/messages', ...options });

/**
 * Delete a channel environment
 */
export const deleteAChannelEnvironmentAsUser = <ThrowOnError extends boolean = true>(options: Options<DeleteAChannelEnvironmentAsUserData, ThrowOnError>) => (options.client ?? client).delete<DeleteAChannelEnvironmentAsUserResponses, unknown, ThrowOnError>({ url: '/user/channels/{channelId}/environment', ...options });

/**
 * Read a channel environment
 */
export const readAChannelEnvironmentAsUser = <ThrowOnError extends boolean = true>(options: Options<ReadAChannelEnvironmentAsUserData, ThrowOnError>) => (options.client ?? client).get<ReadAChannelEnvironmentAsUserResponses, unknown, ThrowOnError>({ url: '/user/channels/{channelId}/environment', ...options });

/**
 * Patch a channel environment
 */
export const patchAChannelEnvironmentAsUser = <ThrowOnError extends boolean = true>(options: Options<PatchAChannelEnvironmentAsUserData, ThrowOnError>) => (options.client ?? client).patch<PatchAChannelEnvironmentAsUserResponses, unknown, ThrowOnError>({
    url: '/user/channels/{channelId}/environment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Attach a channel environment
 */
export const attachAChannelEnvironmentAsUser = <ThrowOnError extends boolean = true>(options: Options<AttachAChannelEnvironmentAsUserData, ThrowOnError>) => (options.client ?? client).post<AttachAChannelEnvironmentAsUserResponses, unknown, ThrowOnError>({
    url: '/user/channels/{channelId}/environment',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List channel environment repository attachments
 */
export const listChannelEnvironmentRepositoryAttachmentsAsUser = <ThrowOnError extends boolean = true>(options: Options<ListChannelEnvironmentRepositoryAttachmentsAsUserData, ThrowOnError>) => (options.client ?? client).get<ListChannelEnvironmentRepositoryAttachmentsAsUserResponses, unknown, ThrowOnError>({ url: '/user/channels/{channelId}/environment/repositories', ...options });

/**
 * Attach a repository to a channel environment
 */
export const attachARepositoryToAChannelEnvironmentAsUser = <ThrowOnError extends boolean = true>(options: Options<AttachARepositoryToAChannelEnvironmentAsUserData, ThrowOnError>) => (options.client ?? client).post<AttachARepositoryToAChannelEnvironmentAsUserResponses, unknown, ThrowOnError>({
    url: '/user/channels/{channelId}/environment/repositories',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mint and launch a channel environment preview port
 */
export const mintAndLaunchAChannelEnvironmentPreviewPortAsUser = <ThrowOnError extends boolean = true>(options: Options<MintAndLaunchAChannelEnvironmentPreviewPortAsUserData, ThrowOnError>) => (options.client ?? client).post<MintAndLaunchAChannelEnvironmentPreviewPortAsUserResponses, unknown, ThrowOnError>({ url: '/user/channels/{channelId}/environment/previews/{publicPort}/launch', ...options });

/**
 * Detach a repository from a channel environment
 */
export const detachARepositoryFromAChannelEnvironmentAsUser = <ThrowOnError extends boolean = true>(options: Options<DetachARepositoryFromAChannelEnvironmentAsUserData, ThrowOnError>) => (options.client ?? client).delete<DetachARepositoryFromAChannelEnvironmentAsUserResponses, unknown, ThrowOnError>({ url: '/user/channels/{channelId}/environment/repositories/{repoAttachmentId}', ...options });

/**
 * Change a channel environment repository branch
 */
export const changeAChannelEnvironmentRepositoryBranchAsUser = <ThrowOnError extends boolean = true>(options: Options<ChangeAChannelEnvironmentRepositoryBranchAsUserData, ThrowOnError>) => (options.client ?? client).patch<ChangeAChannelEnvironmentRepositoryBranchAsUserResponses, unknown, ThrowOnError>({
    url: '/user/channels/{channelId}/environment/repositories/{repoAttachmentId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Refresh a repository attachment to its remote branch head
 */
export const refreshARepositoryAttachmentToItsRemoteBranchHeadAsUser = <ThrowOnError extends boolean = true>(options: Options<RefreshARepositoryAttachmentToItsRemoteBranchHeadAsUserData, ThrowOnError>) => (options.client ?? client).post<RefreshARepositoryAttachmentToItsRemoteBranchHeadAsUserResponses, unknown, ThrowOnError>({
    url: '/user/channels/{channelId}/environment/repositories/{repoAttachmentId}/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Restart a channel environment
 */
export const restartAChannelEnvironmentAsUser = <ThrowOnError extends boolean = true>(options: Options<RestartAChannelEnvironmentAsUserData, ThrowOnError>) => (options.client ?? client).post<RestartAChannelEnvironmentAsUserResponses, unknown, ThrowOnError>({ url: '/user/channels/{channelId}/environment/restart', ...options });

/**
 * Retry starting a channel environment's sandbox
 */
export const retryStartingAChannelEnvironment_sSandboxAsUser = <ThrowOnError extends boolean = true>(options: Options<RetryStartingAChannelEnvironmentSSandboxAsUserData, ThrowOnError>) => (options.client ?? client).post<RetryStartingAChannelEnvironmentSSandboxAsUserResponses, unknown, ThrowOnError>({ url: '/user/channels/{channelId}/environment/start', ...options });

/**
 * Preview checkpoint recovery from a replaced host
 */
export const previewCheckpointRecoveryFromAReplacedHostAsUser = <ThrowOnError extends boolean = true>(options: Options<PreviewCheckpointRecoveryFromAReplacedHostAsUserData, ThrowOnError>) => (options.client ?? client).get<PreviewCheckpointRecoveryFromAReplacedHostAsUserResponses, unknown, ThrowOnError>({ url: '/user/channels/{channelId}/environment/lost-host-recovery', ...options });

/**
 * Prepare checkpoint recovery from a replaced host
 */
export const prepareCheckpointRecoveryFromAReplacedHostAsUser = <ThrowOnError extends boolean = true>(options: Options<PrepareCheckpointRecoveryFromAReplacedHostAsUserData, ThrowOnError>) => (options.client ?? client).post<PrepareCheckpointRecoveryFromAReplacedHostAsUserResponses, unknown, ThrowOnError>({
    url: '/user/channels/{channelId}/environment/lost-host-recovery',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive a channel environment
 */
export const archiveAChannelEnvironmentAsUser = <ThrowOnError extends boolean = true>(options: Options<ArchiveAChannelEnvironmentAsUserData, ThrowOnError>) => (options.client ?? client).post<ArchiveAChannelEnvironmentAsUserResponses, unknown, ThrowOnError>({ url: '/user/channels/{channelId}/environment/archive', ...options });

/**
 * Mint Teams channel binding token
 */
export const mintTeamsChannelBindingTokenAsUser = <ThrowOnError extends boolean = true>(options: Options<MintTeamsChannelBindingTokenAsUserData, ThrowOnError>) => (options.client ?? client).post<MintTeamsChannelBindingTokenAsUserResponses, unknown, ThrowOnError>({ url: '/user/channels/{id}/teams-binding-token', ...options });

/**
 * List selectable channel environment profiles
 */
export const listSelectableChannelEnvironmentProfilesAsUser = <ThrowOnError extends boolean = true>(options?: Options<ListSelectableChannelEnvironmentProfilesAsUserData, ThrowOnError>) => (options?.client ?? client).get<ListSelectableChannelEnvironmentProfilesAsUserResponses, unknown, ThrowOnError>({ url: '/user/channel-environment-profiles', ...options });

/**
 * List flow lock diagnostics
 */
export const listFlowLockDiagnosticsAsUser = <ThrowOnError extends boolean = true>(options?: Options<ListFlowLockDiagnosticsAsUserData, ThrowOnError>) => (options?.client ?? client).get<ListFlowLockDiagnosticsAsUserResponses, unknown, ThrowOnError>({ url: '/user/flows/locks', ...options });

/**
 * Release flow lock
 */
export const releaseFlowLockAsUser = <ThrowOnError extends boolean = true>(options: Options<ReleaseFlowLockAsUserData, ThrowOnError>) => (options.client ?? client).post<ReleaseFlowLockAsUserResponses, unknown, ThrowOnError>({ url: '/user/flows/locks/{storyIssueKey}/release', ...options });

/**
 * Download compile recording artifact
 */
export const downloadCompileRecordingArtifactAsUser = <ThrowOnError extends boolean = true>(options: Options<DownloadCompileRecordingArtifactAsUserData, ThrowOnError>) => (options.client ?? client).get<DownloadCompileRecordingArtifactAsUserResponses, unknown, ThrowOnError>({ url: '/user/flows/{flowId}/recording-artifact', ...options });

/**
 * Retry a failed execution flow
 */
export const retryAFailedExecutionFlowAsUser = <ThrowOnError extends boolean = true>(options: Options<RetryAFailedExecutionFlowAsUserData, ThrowOnError>) => (options.client ?? client).post<RetryAFailedExecutionFlowAsUserResponses, unknown, ThrowOnError>({ url: '/user/flows/{flowId}/retry', ...options });

/**
 * Start a compile recording for a completed execution flow
 */
export const startACompileRecordingForACompletedExecutionFlowAsUser = <ThrowOnError extends boolean = true>(options: Options<StartACompileRecordingForACompletedExecutionFlowAsUserData, ThrowOnError>) => (options.client ?? client).post<StartACompileRecordingForACompletedExecutionFlowAsUserResponses, unknown, ThrowOnError>({ url: '/user/flows/{flowId}/compile-recording', ...options });

/**
 * List flow stage journal
 */
export const listFlowStageJournalAsUser = <ThrowOnError extends boolean = true>(options: Options<ListFlowStageJournalAsUserData, ThrowOnError>) => (options.client ?? client).get<ListFlowStageJournalAsUserResponses, unknown, ThrowOnError>({ url: '/user/flows/{flowId}/stage-journal', ...options });

/**
 * Get flow stage journal entry
 */
export const getFlowStageJournalEntryAsUser = <ThrowOnError extends boolean = true>(options: Options<GetFlowStageJournalEntryAsUserData, ThrowOnError>) => (options.client ?? client).get<GetFlowStageJournalEntryAsUserResponses, unknown, ThrowOnError>({ url: '/user/flows/{flowId}/stage-journal/{entryId}', ...options });

/**
 * Get flow details
 */
export const getFlowDetailsAsUser = <ThrowOnError extends boolean = true>(options: Options<GetFlowDetailsAsUserData, ThrowOnError>) => (options.client ?? client).get<GetFlowDetailsAsUserResponses, unknown, ThrowOnError>({ url: '/user/flows/{flowId}', ...options });

export const getUserInstances = <ThrowOnError extends boolean = true>(options?: Options<GetUserInstancesData, ThrowOnError>) => (options?.client ?? client).get<GetUserInstancesResponses, unknown, ThrowOnError>({ url: '/user/instances', ...options });

export const getUserInstancesByIdChannelsByChannelIdMessages = <ThrowOnError extends boolean = true>(options: Options<GetUserInstancesByIdChannelsByChannelIdMessagesData, ThrowOnError>) => (options.client ?? client).get<GetUserInstancesByIdChannelsByChannelIdMessagesResponses, unknown, ThrowOnError>({ url: '/user/instances/{id}/channels/{channelId}/messages', ...options });

export const getUserInstancesByIdCost = <ThrowOnError extends boolean = true>(options: Options<GetUserInstancesByIdCostData, ThrowOnError>) => (options.client ?? client).get<GetUserInstancesByIdCostResponses, unknown, ThrowOnError>({ url: '/user/instances/{id}/cost', ...options });

export const getUserInstancesByIdMemory = <ThrowOnError extends boolean = true>(options: Options<GetUserInstancesByIdMemoryData, ThrowOnError>) => (options.client ?? client).get<GetUserInstancesByIdMemoryResponses, unknown, ThrowOnError>({ url: '/user/instances/{id}/memory', ...options });

export const getUserInstancesByIdObservabilityList = <ThrowOnError extends boolean = true>(options: Options<GetUserInstancesByIdObservabilityListData, ThrowOnError>) => (options.client ?? client).get<GetUserInstancesByIdObservabilityListResponses, unknown, ThrowOnError>({ url: '/user/instances/{id}/observability/list', ...options });

export const getUserInstancesByIdObservabilityDiff = <ThrowOnError extends boolean = true>(options: Options<GetUserInstancesByIdObservabilityDiffData, ThrowOnError>) => (options.client ?? client).get<GetUserInstancesByIdObservabilityDiffResponses, unknown, ThrowOnError>({ url: '/user/instances/{id}/observability/diff', ...options });

export const getUserInstancesGrowthDistribution = <ThrowOnError extends boolean = true>(options?: Options<GetUserInstancesGrowthDistributionData, ThrowOnError>) => (options?.client ?? client).get<GetUserInstancesGrowthDistributionResponses, unknown, ThrowOnError>({ url: '/user/instances/growth-distribution', ...options });

export const getUserInstancesByIdChannelsByChannelIdArtifacts = <ThrowOnError extends boolean = true>(options: Options<GetUserInstancesByIdChannelsByChannelIdArtifactsData, ThrowOnError>) => (options.client ?? client).get<GetUserInstancesByIdChannelsByChannelIdArtifactsResponses, unknown, ThrowOnError>({ url: '/user/instances/{id}/channels/{channelId}/artifacts', ...options });

/**
 * Get dashboard overview
 */
export const getDashboardOverviewAsUser = <ThrowOnError extends boolean = true>(options?: Options<GetDashboardOverviewAsUserData, ThrowOnError>) => (options?.client ?? client).get<GetDashboardOverviewAsUserResponses, unknown, ThrowOnError>({ url: '/user/overview', ...options });

/**
 * List tasks
 */
export const listTasksAsUser = <ThrowOnError extends boolean = true>(options?: Options<ListTasksAsUserData, ThrowOnError>) => (options?.client ?? client).get<ListTasksAsUserResponses, unknown, ThrowOnError>({ url: '/user/tasks', ...options });

/**
 * Get task facets
 */
export const getTaskFacetsAsUser = <ThrowOnError extends boolean = true>(options?: Options<GetTaskFacetsAsUserData, ThrowOnError>) => (options?.client ?? client).get<GetTaskFacetsAsUserResponses, unknown, ThrowOnError>({ url: '/user/tasks/facets', ...options });

/**
 * Cancel tasks
 */
export const cancelTasksAsUser = <ThrowOnError extends boolean = true>(options?: Options<CancelTasksAsUserData, ThrowOnError>) => (options?.client ?? client).post<CancelTasksAsUserResponses, unknown, ThrowOnError>({
    url: '/user/tasks/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get task details
 */
export const getTaskDetailsAsUser = <ThrowOnError extends boolean = true>(options: Options<GetTaskDetailsAsUserData, ThrowOnError>) => (options.client ?? client).get<GetTaskDetailsAsUserResponses, unknown, ThrowOnError>({ url: '/user/tasks/{taskId}/details', ...options });

/**
 * Get task events
 */
export const getTaskEventsAsUser = <ThrowOnError extends boolean = true>(options: Options<GetTaskEventsAsUserData, ThrowOnError>) => (options.client ?? client).get<GetTaskEventsAsUserResponses, unknown, ThrowOnError>({ url: '/user/tasks/{taskId}/events', ...options });

/**
 * Get task logs
 */
export const getTaskLogsAsUser = <ThrowOnError extends boolean = true>(options: Options<GetTaskLogsAsUserData, ThrowOnError>) => (options.client ?? client).get<GetTaskLogsAsUserResponses, unknown, ThrowOnError>({ url: '/user/tasks/{taskId}/logs', ...options });

/**
 * Get Teams integration status
 */
export const getTeamsIntegrationStatusAsUser = <ThrowOnError extends boolean = true>(options?: Options<GetTeamsIntegrationStatusAsUserData, ThrowOnError>) => (options?.client ?? client).get<GetTeamsIntegrationStatusAsUserResponses, unknown, ThrowOnError>({ url: '/user/teams/status', ...options });

/**
 * Get plan revision telemetry
 */
export const getPlanRevisionTelemetryAsUser = <ThrowOnError extends boolean = true>(options: Options<GetPlanRevisionTelemetryAsUserData, ThrowOnError>) => (options.client ?? client).get<GetPlanRevisionTelemetryAsUserResponses, unknown, ThrowOnError>({ url: '/user/plan-revisions/{revisionId}/telemetry', ...options });

/**
 * Get plan revision graph
 */
export const getPlanRevisionGraphAsUser = <ThrowOnError extends boolean = true>(options: Options<GetPlanRevisionGraphAsUserData, ThrowOnError>) => (options.client ?? client).get<GetPlanRevisionGraphAsUserResponses, unknown, ThrowOnError>({ url: '/user/plan-revisions/{revisionId}/graph', ...options });

/**
 * List recent plan snapshots
 */
export const listRecentPlanSnapshotsAsUser = <ThrowOnError extends boolean = true>(options?: Options<ListRecentPlanSnapshotsAsUserData, ThrowOnError>) => (options?.client ?? client).get<ListRecentPlanSnapshotsAsUserResponses, unknown, ThrowOnError>({ url: '/user/plan-snapshots/recent', ...options });

/**
 * Get plan snapshot by story issue key
 */
export const getPlanSnapshotByStoryIssueKeyAsUser = <ThrowOnError extends boolean = true>(options: Options<GetPlanSnapshotByStoryIssueKeyAsUserData, ThrowOnError>) => (options.client ?? client).get<GetPlanSnapshotByStoryIssueKeyAsUserResponses, unknown, ThrowOnError>({ url: '/user/plan-snapshots/story/{storyIssueKey}', ...options });

/**
 * Get plan snapshot by issue key
 */
export const getPlanSnapshotByIssueKeyAsUser = <ThrowOnError extends boolean = true>(options: Options<GetPlanSnapshotByIssueKeyAsUserData, ThrowOnError>) => (options.client ?? client).get<GetPlanSnapshotByIssueKeyAsUserResponses, unknown, ThrowOnError>({ url: '/user/plan-snapshots/issue/{issueKey}', ...options });

/**
 * Get plan snapshot by ID
 */
export const getPlanSnapshotByIdAsUser = <ThrowOnError extends boolean = true>(options: Options<GetPlanSnapshotByIdAsUserData, ThrowOnError>) => (options.client ?? client).get<GetPlanSnapshotByIdAsUserResponses, unknown, ThrowOnError>({ url: '/user/plan-snapshots/{snapshotId}', ...options });

/**
 * List agent mode budgets
 */
export const listAgentModeBudgetsAsUser = <ThrowOnError extends boolean = true>(options?: Options<ListAgentModeBudgetsAsUserData, ThrowOnError>) => (options?.client ?? client).get<ListAgentModeBudgetsAsUserResponses, unknown, ThrowOnError>({ url: '/user/agent-modes/budgets', ...options });

/**
 * Upsert agent mode budgets
 */
export const upsertAgentModeBudgetsAsUser = <ThrowOnError extends boolean = true>(options?: Options<UpsertAgentModeBudgetsAsUserData, ThrowOnError>) => (options?.client ?? client).put<UpsertAgentModeBudgetsAsUserResponses, unknown, ThrowOnError>({
    url: '/user/agent-modes/budgets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Select organization
 */
export const selectOrganizationAsUser = <ThrowOnError extends boolean = true>(options?: Options<SelectOrganizationAsUserData, ThrowOnError>) => (options?.client ?? client).post<SelectOrganizationAsUserResponses, unknown, ThrowOnError>({
    url: '/user/auth/organizations/select',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * List connected MCP OAuth grants
 */
export const listConnectedMcpOauthGrantsAsUser = <ThrowOnError extends boolean = true>(options?: Options<ListConnectedMcpOauthGrantsAsUserData, ThrowOnError>) => (options?.client ?? client).get<ListConnectedMcpOauthGrantsAsUserResponses, unknown, ThrowOnError>({ url: '/user/mcp/grants', ...options });

/**
 * List MCP access tokens
 */
export const listMcpAccessTokensAsUser = <ThrowOnError extends boolean = true>(options?: Options<ListMcpAccessTokensAsUserData, ThrowOnError>) => (options?.client ?? client).get<ListMcpAccessTokensAsUserResponses, unknown, ThrowOnError>({ url: '/user/mcp/tokens', ...options });

/**
 * Create MCP access token
 */
export const createMcpAccessTokenAsUser = <ThrowOnError extends boolean = true>(options?: Options<CreateMcpAccessTokenAsUserData, ThrowOnError>) => (options?.client ?? client).post<CreateMcpAccessTokenAsUserResponses, unknown, ThrowOnError>({
    url: '/user/mcp/tokens',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Revoke MCP OAuth grant
 */
export const revokeMcpOauthGrantAsUser = <ThrowOnError extends boolean = true>(options: Options<RevokeMcpOauthGrantAsUserData, ThrowOnError>) => (options.client ?? client).delete<RevokeMcpOauthGrantAsUserResponses, unknown, ThrowOnError>({ url: '/user/mcp/grants/{grantId}', ...options });

/**
 * Revoke MCP access token
 */
export const revokeMcpAccessTokenAsUser = <ThrowOnError extends boolean = true>(options: Options<RevokeMcpAccessTokenAsUserData, ThrowOnError>) => (options.client ?? client).delete<RevokeMcpAccessTokenAsUserResponses, unknown, ThrowOnError>({ url: '/user/mcp/tokens/{tokenId}', ...options });

/**
 * List organization MCP servers
 */
export const listOrganizationMcpServersAsUser = <ThrowOnError extends boolean = true>(options?: Options<ListOrganizationMcpServersAsUserData, ThrowOnError>) => (options?.client ?? client).get<ListOrganizationMcpServersAsUserResponses, unknown, ThrowOnError>({ url: '/user/mcp-servers', ...options });

/**
 * Register an MCP server for the organization
 */
export const registerAnMcpServerForTheOrganizationAsUser = <ThrowOnError extends boolean = true>(options?: Options<RegisterAnMcpServerForTheOrganizationAsUserData, ThrowOnError>) => (options?.client ?? client).post<RegisterAnMcpServerForTheOrganizationAsUserResponses, unknown, ThrowOnError>({
    url: '/user/mcp-servers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Remove an organization MCP server
 */
export const removeAnOrganizationMcpServerAsUser = <ThrowOnError extends boolean = true>(options: Options<RemoveAnOrganizationMcpServerAsUserData, ThrowOnError>) => (options.client ?? client).delete<RemoveAnOrganizationMcpServerAsUserResponses, unknown, ThrowOnError>({ url: '/user/mcp-servers/{mcpServerId}', ...options });

/**
 * Update an organization MCP server
 */
export const updateAnOrganizationMcpServerAsUser = <ThrowOnError extends boolean = true>(options: Options<UpdateAnOrganizationMcpServerAsUserData, ThrowOnError>) => (options.client ?? client).patch<UpdateAnOrganizationMcpServerAsUserResponses, unknown, ThrowOnError>({
    url: '/user/mcp-servers/{mcpServerId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List organizations
 */
export const listOrganizationsAsUser = <ThrowOnError extends boolean = true>(options?: Options<ListOrganizationsAsUserData, ThrowOnError>) => (options?.client ?? client).get<ListOrganizationsAsUserResponses, unknown, ThrowOnError>({ url: '/user/organizations', ...options });

/**
 * Create organization
 */
export const createOrganizationAsUser = <ThrowOnError extends boolean = true>(options?: Options<CreateOrganizationAsUserData, ThrowOnError>) => (options?.client ?? client).post<CreateOrganizationAsUserResponses, unknown, ThrowOnError>({
    url: '/user/organizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * List organization API keys
 */
export const listOrganizationApiKeysAsUser = <ThrowOnError extends boolean = true>(options: Options<ListOrganizationApiKeysAsUserData, ThrowOnError>) => (options.client ?? client).get<ListOrganizationApiKeysAsUserResponses, unknown, ThrowOnError>({ url: '/user/organizations/{organizationId}/api-keys', ...options });

/**
 * Set up organization billing
 */
export const setUpOrganizationBillingAsUser = <ThrowOnError extends boolean = true>(options: Options<SetUpOrganizationBillingAsUserData, ThrowOnError>) => (options.client ?? client).post<SetUpOrganizationBillingAsUserResponses, unknown, ThrowOnError>({ url: '/user/organizations/{organizationId}/billing/setup', ...options });

/**
 * Create topup session
 */
export const createTopupSessionAsUser = <ThrowOnError extends boolean = true>(options: Options<CreateTopupSessionAsUserData, ThrowOnError>) => (options.client ?? client).post<CreateTopupSessionAsUserResponses, unknown, ThrowOnError>({
    url: '/user/organizations/{organizationId}/billing/topup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get billing balance
 */
export const getBillingBalanceAsUser = <ThrowOnError extends boolean = true>(options: Options<GetBillingBalanceAsUserData, ThrowOnError>) => (options.client ?? client).get<GetBillingBalanceAsUserResponses, unknown, ThrowOnError>({ url: '/user/organizations/{organizationId}/billing/balance', ...options });

/**
 * List billing transactions
 */
export const listBillingTransactionsAsUser = <ThrowOnError extends boolean = true>(options: Options<ListBillingTransactionsAsUserData, ThrowOnError>) => (options.client ?? client).get<ListBillingTransactionsAsUserResponses, unknown, ThrowOnError>({ url: '/user/organizations/{organizationId}/billing/transactions', ...options });

/**
 * Create billing portal session
 */
export const createBillingPortalSessionAsUser = <ThrowOnError extends boolean = true>(options: Options<CreateBillingPortalSessionAsUserData, ThrowOnError>) => (options.client ?? client).post<CreateBillingPortalSessionAsUserResponses, unknown, ThrowOnError>({
    url: '/user/organizations/{organizationId}/billing/portal',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List organization invites
 */
export const listOrganizationInvitesAsUser = <ThrowOnError extends boolean = true>(options: Options<ListOrganizationInvitesAsUserData, ThrowOnError>) => (options.client ?? client).get<ListOrganizationInvitesAsUserResponses, unknown, ThrowOnError>({ url: '/user/organizations/{organizationId}/invites', ...options });

/**
 * Invalidate organization invite
 */
export const invalidateOrganizationInviteAsUser = <ThrowOnError extends boolean = true>(options: Options<InvalidateOrganizationInviteAsUserData, ThrowOnError>) => (options.client ?? client).delete<InvalidateOrganizationInviteAsUserResponses, unknown, ThrowOnError>({ url: '/user/organizations/{organizationId}/invites/{inviteId}', ...options });

/**
 * List organization members
 */
export const listOrganizationMembersAsUser = <ThrowOnError extends boolean = true>(options: Options<ListOrganizationMembersAsUserData, ThrowOnError>) => (options.client ?? client).get<ListOrganizationMembersAsUserResponses, unknown, ThrowOnError>({ url: '/user/organizations/{organizationId}/members', ...options });

/**
 * Invite organization member
 */
export const inviteOrganizationMemberAsUser = <ThrowOnError extends boolean = true>(options: Options<InviteOrganizationMemberAsUserData, ThrowOnError>) => (options.client ?? client).post<InviteOrganizationMemberAsUserResponses, unknown, ThrowOnError>({
    url: '/user/organizations/{organizationId}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove member
 */
export const removeMemberAsUser = <ThrowOnError extends boolean = true>(options: Options<RemoveMemberAsUserData, ThrowOnError>) => (options.client ?? client).delete<RemoveMemberAsUserResponses, unknown, ThrowOnError>({ url: '/user/organizations/{organizationId}/members/{memberId}', ...options });

/**
 * Update member role
 */
export const updateMemberRoleAsUser = <ThrowOnError extends boolean = true>(options: Options<UpdateMemberRoleAsUserData, ThrowOnError>) => (options.client ?? client).patch<UpdateMemberRoleAsUserResponses, unknown, ThrowOnError>({
    url: '/user/organizations/{organizationId}/members/{memberId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get organization
 */
export const getOrganizationAsUser = <ThrowOnError extends boolean = true>(options: Options<GetOrganizationAsUserData, ThrowOnError>) => (options.client ?? client).get<GetOrganizationAsUserResponses, unknown, ThrowOnError>({ url: '/user/organizations/{organizationId}', ...options });

/**
 * List pending invites
 */
export const listPendingInvitesAsUser = <ThrowOnError extends boolean = true>(options?: Options<ListPendingInvitesAsUserData, ThrowOnError>) => (options?.client ?? client).get<ListPendingInvitesAsUserResponses, unknown, ThrowOnError>({ url: '/user/invites/pending', ...options });

/**
 * Get invite by token
 */
export const getInviteByTokenAsUser = <ThrowOnError extends boolean = true>(options: Options<GetInviteByTokenAsUserData, ThrowOnError>) => (options.client ?? client).get<GetInviteByTokenAsUserResponses, unknown, ThrowOnError>({ url: '/user/invites/{token}', ...options });

/**
 * Accept invite
 */
export const acceptInviteAsUser = <ThrowOnError extends boolean = true>(options: Options<AcceptInviteAsUserData, ThrowOnError>) => (options.client ?? client).post<AcceptInviteAsUserResponses, unknown, ThrowOnError>({ url: '/user/invites/{token}/accept', ...options });

/**
 * Decline invite
 */
export const declineInviteAsUser = <ThrowOnError extends boolean = true>(options: Options<DeclineInviteAsUserData, ThrowOnError>) => (options.client ?? client).post<DeclineInviteAsUserResponses, unknown, ThrowOnError>({ url: '/user/invites/{token}/decline', ...options });

/**
 * List issue integration providers
 */
export const listIssueIntegrationProvidersAsUser = <ThrowOnError extends boolean = true>(options?: Options<ListIssueIntegrationProvidersAsUserData, ThrowOnError>) => (options?.client ?? client).get<ListIssueIntegrationProvidersAsUserResponses, unknown, ThrowOnError>({ url: '/user/issue-integrations/providers', ...options });

/**
 * Get issue integration provider detail
 */
export const getIssueIntegrationProviderDetailAsUser = <ThrowOnError extends boolean = true>(options: Options<GetIssueIntegrationProviderDetailAsUserData, ThrowOnError>) => (options.client ?? client).get<GetIssueIntegrationProviderDetailAsUserResponses, unknown, ThrowOnError>({ url: '/user/issue-integrations/providers/{providerId}', ...options });

/**
 * Create issue integration project
 */
export const createIssueIntegrationProjectAsUser = <ThrowOnError extends boolean = true>(options: Options<CreateIssueIntegrationProjectAsUserData, ThrowOnError>) => (options.client ?? client).post<CreateIssueIntegrationProjectAsUserResponses, unknown, ThrowOnError>({
    url: '/user/issue-integrations/providers/{providerId}/projects',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Discover remote issue projects
 */
export const discoverRemoteIssueProjectsAsUser = <ThrowOnError extends boolean = true>(options: Options<DiscoverRemoteIssueProjectsAsUserData, ThrowOnError>) => (options.client ?? client).get<DiscoverRemoteIssueProjectsAsUserResponses, unknown, ThrowOnError>({ url: '/user/issue-integrations/providers/{providerId}/projects/remote', ...options });

/**
 * Issue integration OAuth callback
 */
export const issueIntegrationOauthCallbackAsUser = <ThrowOnError extends boolean = true>(options: Options<IssueIntegrationOauthCallbackAsUserData, ThrowOnError>) => (options.client ?? client).get<IssueIntegrationOauthCallbackAsUserResponses, unknown, ThrowOnError>({ url: '/user/issue-integrations/oauth/callback', ...options });

/**
 * Generate Jira link code
 */
export const generateJiraLinkCodeAsUser = <ThrowOnError extends boolean = true>(options?: Options<GenerateJiraLinkCodeAsUserData, ThrowOnError>) => (options?.client ?? client).post<GenerateJiraLinkCodeAsUserResponses, unknown, ThrowOnError>({ url: '/user/issue-integrations/jira/link-code', ...options });

/**
 * Launch or resume a channel workspace from an issue
 */
export const launchOrResumeAChannelWorkspaceFromAnIssueAsUser = <ThrowOnError extends boolean = true>(options?: Options<LaunchOrResumeAChannelWorkspaceFromAnIssueAsUserData, ThrowOnError>) => (options?.client ?? client).post<LaunchOrResumeAChannelWorkspaceFromAnIssueAsUserResponses, unknown, ThrowOnError>({
    url: '/user/issue-workspaces',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Permanently delete an issue workspace aggregate
 */
export const permanentlyDeleteAnIssueWorkspaceAggregateAsUser = <ThrowOnError extends boolean = true>(options: Options<PermanentlyDeleteAnIssueWorkspaceAggregateAsUserData, ThrowOnError>) => (options.client ?? client).delete<PermanentlyDeleteAnIssueWorkspaceAggregateAsUserResponses, unknown, ThrowOnError>({ url: '/user/issue-workspaces/{channelId}', ...options });

/**
 * List or search issues using structured filters
 */
export const listOrSearchIssuesUsingStructuredFiltersAsUser = <ThrowOnError extends boolean = true>(options?: Options<ListOrSearchIssuesUsingStructuredFiltersAsUserData, ThrowOnError>) => (options?.client ?? client).get<ListOrSearchIssuesUsingStructuredFiltersAsUserResponses, unknown, ThrowOnError>({ url: '/user/issues', ...options });

/**
 * Get issue details
 */
export const getIssueDetailsAsUser = <ThrowOnError extends boolean = true>(options: Options<GetIssueDetailsAsUserData, ThrowOnError>) => (options.client ?? client).get<GetIssueDetailsAsUserResponses, unknown, ThrowOnError>({ url: '/user/issues/{providerId}/{issueKey}', ...options });

/**
 * List source control providers
 */
export const listSourceControlProvidersAsUser = <ThrowOnError extends boolean = true>(options?: Options<ListSourceControlProvidersAsUserData, ThrowOnError>) => (options?.client ?? client).get<ListSourceControlProvidersAsUserResponses, unknown, ThrowOnError>({ url: '/user/source-control/providers', ...options });

/**
 * Create source control provider
 */
export const createSourceControlProviderAsUser = <ThrowOnError extends boolean = true>(options?: Options<CreateSourceControlProviderAsUserData, ThrowOnError>) => (options?.client ?? client).post<CreateSourceControlProviderAsUserResponses, unknown, ThrowOnError>({
    url: '/user/source-control/providers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get source control provider detail
 */
export const getSourceControlProviderDetailAsUser = <ThrowOnError extends boolean = true>(options: Options<GetSourceControlProviderDetailAsUserData, ThrowOnError>) => (options.client ?? client).get<GetSourceControlProviderDetailAsUserResponses, unknown, ThrowOnError>({ url: '/user/source-control/providers/{providerId}', ...options });

/**
 * Discover remote repositories
 */
export const discoverRemoteRepositoriesAsUser = <ThrowOnError extends boolean = true>(options: Options<DiscoverRemoteRepositoriesAsUserData, ThrowOnError>) => (options.client ?? client).get<DiscoverRemoteRepositoriesAsUserResponses, unknown, ThrowOnError>({ url: '/user/source-control/providers/{providerId}/discover-repositories', ...options });

/**
 * Discover remote branches
 */
export const discoverRemoteBranchesAsUser = <ThrowOnError extends boolean = true>(options: Options<DiscoverRemoteBranchesAsUserData, ThrowOnError>) => (options.client ?? client).get<DiscoverRemoteBranchesAsUserResponses, unknown, ThrowOnError>({ url: '/user/source-control/providers/{providerId}/discover-branches', ...options });

/**
 * Create source control credential
 */
export const createSourceControlCredentialAsUser = <ThrowOnError extends boolean = true>(options: Options<CreateSourceControlCredentialAsUserData, ThrowOnError>) => (options.client ?? client).post<CreateSourceControlCredentialAsUserResponses, unknown, ThrowOnError>({
    url: '/user/source-control/providers/{providerId}/credentials',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify source control credential
 */
export const verifySourceControlCredentialAsUser = <ThrowOnError extends boolean = true>(options: Options<VerifySourceControlCredentialAsUserData, ThrowOnError>) => (options.client ?? client).post<VerifySourceControlCredentialAsUserResponses, unknown, ThrowOnError>({ url: '/user/source-control/providers/{providerId}/credentials/{credentialId}/verify', ...options });

/**
 * Update source control credential
 */
export const updateSourceControlCredentialAsUser = <ThrowOnError extends boolean = true>(options: Options<UpdateSourceControlCredentialAsUserData, ThrowOnError>) => (options.client ?? client).patch<UpdateSourceControlCredentialAsUserResponses, unknown, ThrowOnError>({
    url: '/user/source-control/providers/{providerId}/credentials/{credentialId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upsert source control repositories
 */
export const upsertSourceControlRepositoriesAsUser = <ThrowOnError extends boolean = true>(options: Options<UpsertSourceControlRepositoriesAsUserData, ThrowOnError>) => (options.client ?? client).put<UpsertSourceControlRepositoriesAsUserResponses, unknown, ThrowOnError>({
    url: '/user/source-control/providers/{providerId}/repositories',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete source control webhook
 */
export const deleteSourceControlWebhookAsUser = <ThrowOnError extends boolean = true>(options: Options<DeleteSourceControlWebhookAsUserData, ThrowOnError>) => (options.client ?? client).delete<DeleteSourceControlWebhookAsUserResponses, unknown, ThrowOnError>({ url: '/user/source-control/providers/{providerId}/webhooks/{webhookId}', ...options });

/**
 * Setup GitHub org webhook
 */
export const setupGithubOrgWebhookAsUser = <ThrowOnError extends boolean = true>(options: Options<SetupGithubOrgWebhookAsUserData, ThrowOnError>) => (options.client ?? client).post<SetupGithubOrgWebhookAsUserResponses, unknown, ThrowOnError>({
    url: '/user/source-control/providers/{providerId}/github/setup-webhook',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Setup GitHub App installation
 */
export const setupGithubAppInstallationAsUser = <ThrowOnError extends boolean = true>(options: Options<SetupGithubAppInstallationAsUserData, ThrowOnError>) => (options.client ?? client).post<SetupGithubAppInstallationAsUserResponses, unknown, ThrowOnError>({
    url: '/user/source-control/providers/{providerId}/github/setup-app-installation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete source control credential
 */
export const deleteSourceControlCredentialAsUser = <ThrowOnError extends boolean = true>(options: Options<DeleteSourceControlCredentialAsUserData, ThrowOnError>) => (options.client ?? client).delete<DeleteSourceControlCredentialAsUserResponses, unknown, ThrowOnError>({ url: '/user/source-control/credentials/{credentialId}', ...options });

/**
 * List source control repository summaries
 */
export const listSourceControlRepositorySummariesAsUser = <ThrowOnError extends boolean = true>(options?: Options<ListSourceControlRepositorySummariesAsUserData, ThrowOnError>) => (options?.client ?? client).get<ListSourceControlRepositorySummariesAsUserResponses, unknown, ThrowOnError>({ url: '/user/source-control/repositories/summary', ...options });

/**
 * Delete repository
 */
export const deleteRepositoryAsUser = <ThrowOnError extends boolean = true>(options: Options<DeleteRepositoryAsUserData, ThrowOnError>) => (options.client ?? client).delete<DeleteRepositoryAsUserResponses, unknown, ThrowOnError>({ url: '/user/source-control/repositories/{providerId}/{repositoryId}', ...options });

/**
 * List indexing runs
 */
export const listIndexingRunsAsUser = <ThrowOnError extends boolean = true>(options?: Options<ListIndexingRunsAsUserData, ThrowOnError>) => (options?.client ?? client).get<ListIndexingRunsAsUserResponses, unknown, ThrowOnError>({ url: '/user/source-control/indexing/runs', ...options });

/**
 * Create indexing run
 */
export const createIndexingRunAsUser = <ThrowOnError extends boolean = true>(options?: Options<CreateIndexingRunAsUserData, ThrowOnError>) => (options?.client ?? client).post<CreateIndexingRunAsUserResponses, unknown, ThrowOnError>({
    url: '/user/source-control/indexing/runs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get failed repositories for indexing run
 */
export const getFailedRepositoriesForIndexingRunAsUser = <ThrowOnError extends boolean = true>(options: Options<GetFailedRepositoriesForIndexingRunAsUserData, ThrowOnError>) => (options.client ?? client).get<GetFailedRepositoriesForIndexingRunAsUserResponses, unknown, ThrowOnError>({ url: '/user/source-control/indexing/runs/{runId}/failed-repositories', ...options });

/**
 * Get indexing run insights
 */
export const getIndexingRunInsightsAsUser = <ThrowOnError extends boolean = true>(options: Options<GetIndexingRunInsightsAsUserData, ThrowOnError>) => (options.client ?? client).get<GetIndexingRunInsightsAsUserResponses, unknown, ThrowOnError>({ url: '/user/source-control/indexing/runs/{runId}/insights', ...options });

/**
 * Get repository topology
 */
export const getRepositoryTopologyAsUser = <ThrowOnError extends boolean = true>(options?: Options<GetRepositoryTopologyAsUserData, ThrowOnError>) => (options?.client ?? client).get<GetRepositoryTopologyAsUserResponses, unknown, ThrowOnError>({ url: '/user/source-control/indexing/topology', ...options });

/**
 * List repository chat conversations
 */
export const listRepositoryChatConversationsAsUser = <ThrowOnError extends boolean = true>(options?: Options<ListRepositoryChatConversationsAsUserData, ThrowOnError>) => (options?.client ?? client).get<ListRepositoryChatConversationsAsUserResponses, unknown, ThrowOnError>({ url: '/user/source-control/chat/conversations', ...options });

/**
 * Create a new repository chat conversation
 */
export const createANewRepositoryChatConversationAsUser = <ThrowOnError extends boolean = true>(options?: Options<CreateANewRepositoryChatConversationAsUserData, ThrowOnError>) => (options?.client ?? client).post<CreateANewRepositoryChatConversationAsUserResponses, unknown, ThrowOnError>({
    url: '/user/source-control/chat/conversations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get a repository chat conversation
 */
export const getARepositoryChatConversationAsUser = <ThrowOnError extends boolean = true>(options: Options<GetARepositoryChatConversationAsUserData, ThrowOnError>) => (options.client ?? client).get<GetARepositoryChatConversationAsUserResponses, unknown, ThrowOnError>({ url: '/user/source-control/chat/conversations/{conversationId}', ...options });

/**
 * Create a repository chat message
 */
export const createARepositoryChatMessageAsUser = <ThrowOnError extends boolean = true>(options: Options<CreateARepositoryChatMessageAsUserData, ThrowOnError>) => (options.client ?? client).post<CreateARepositoryChatMessageAsUserResponses, unknown, ThrowOnError>({
    url: '/user/source-control/chat/conversations/{conversationId}/messages',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stream repository chat message responses
 */
export const postUserSourceControlChatConversationsByConversationIdMessagesStream = <ThrowOnError extends boolean = true>(options: Options<PostUserSourceControlChatConversationsByConversationIdMessagesStreamData, ThrowOnError>) => (options.client ?? client).sse.post<PostUserSourceControlChatConversationsByConversationIdMessagesStreamResponses, unknown, ThrowOnError>({
    url: '/user/source-control/chat/conversations/{conversationId}/messages/stream',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get push broker overview
 */
export const getPushBrokerOverviewAsUser = <ThrowOnError extends boolean = true>(options?: Options<GetPushBrokerOverviewAsUserData, ThrowOnError>) => (options?.client ?? client).get<GetPushBrokerOverviewAsUserResponses, unknown, ThrowOnError>({ url: '/user/source-control/push-broker', ...options });

/**
 * List push policies for a channel environment
 */
export const listPushPoliciesForAChannelEnvironmentAsUser = <ThrowOnError extends boolean = true>(options: Options<ListPushPoliciesForAChannelEnvironmentAsUserData, ThrowOnError>) => (options.client ?? client).get<ListPushPoliciesForAChannelEnvironmentAsUserResponses, unknown, ThrowOnError>({ url: '/user/source-control/push-broker/policies', ...options });

/**
 * Enable or disable push for a repository attachment
 */
export const enableOrDisablePushForARepositoryAttachmentAsUser = <ThrowOnError extends boolean = true>(options?: Options<EnableOrDisablePushForARepositoryAttachmentAsUserData, ThrowOnError>) => (options?.client ?? client).post<EnableOrDisablePushForARepositoryAttachmentAsUserResponses, unknown, ThrowOnError>({
    url: '/user/source-control/push-broker/policy',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Activate repository writes for a workspace if absent
 */
export const activateRepositoryWritesForAWorkspaceIfAbsentAsUser = <ThrowOnError extends boolean = true>(options?: Options<ActivateRepositoryWritesForAWorkspaceIfAbsentAsUserData, ThrowOnError>) => (options?.client ?? client).post<ActivateRepositoryWritesForAWorkspaceIfAbsentAsUserResponses, unknown, ThrowOnError>({
    url: '/user/source-control/push-broker/allowlist/activate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Review repository writes before an org-wide activation
 */
export const reviewRepositoryWritesBeforeAnOrgWideActivationAsUser = <ThrowOnError extends boolean = true>(options: Options<ReviewRepositoryWritesBeforeAnOrgWideActivationAsUserData, ThrowOnError>) => (options.client ?? client).get<ReviewRepositoryWritesBeforeAnOrgWideActivationAsUserResponses, unknown, ThrowOnError>({ url: '/user/source-control/push-broker/allowlist/review', ...options });

/**
 * Activate repository writes organization-wide after review
 */
export const activateRepositoryWritesOrganizationWideAfterReviewAsUser = <ThrowOnError extends boolean = true>(options?: Options<ActivateRepositoryWritesOrganizationWideAfterReviewAsUserData, ThrowOnError>) => (options?.client ?? client).post<ActivateRepositoryWritesOrganizationWideAfterReviewAsUserResponses, unknown, ThrowOnError>({
    url: '/user/source-control/push-broker/allowlist/admin/activate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Re-authorize revoked repository writes
 */
export const reAuthorizeRevokedRepositoryWritesAsUser = <ThrowOnError extends boolean = true>(options?: Options<ReAuthorizeRevokedRepositoryWritesAsUserData, ThrowOnError>) => (options?.client ?? client).post<ReAuthorizeRevokedRepositoryWritesAsUserResponses, unknown, ThrowOnError>({
    url: '/user/source-control/push-broker/allowlist/admin/reauthorize',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Revoke repository writes organization-wide
 */
export const revokeRepositoryWritesOrganizationWideAsUser = <ThrowOnError extends boolean = true>(options?: Options<RevokeRepositoryWritesOrganizationWideAsUserData, ThrowOnError>) => (options?.client ?? client).post<RevokeRepositoryWritesOrganizationWideAsUserResponses, unknown, ThrowOnError>({
    url: '/user/source-control/push-broker/allowlist/admin/revoke',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Get schema telemetry scope summary
 */
export const getSchemaTelemetryScopeSummaryAsUser = <ThrowOnError extends boolean = true>(options?: Options<GetSchemaTelemetryScopeSummaryAsUserData, ThrowOnError>) => (options?.client ?? client).get<GetSchemaTelemetryScopeSummaryAsUserResponses, unknown, ThrowOnError>({ url: '/user/schema-telemetry/scope-summary', ...options });

/**
 * Export schema telemetry
 */
export const exportSchemaTelemetryAsUser = <ThrowOnError extends boolean = true>(options?: Options<ExportSchemaTelemetryAsUserData, ThrowOnError>) => (options?.client ?? client).post<ExportSchemaTelemetryAsUserResponses, unknown, ThrowOnError>({
    url: '/user/schema-telemetry/export',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Download telemetry prompt
 */
export const downloadTelemetryPromptAsUser = <ThrowOnError extends boolean = true>(options: Options<DownloadTelemetryPromptAsUserData, ThrowOnError>) => (options.client ?? client).get<DownloadTelemetryPromptAsUserResponses, unknown, ThrowOnError>({ url: '/user/schema-telemetry/{id}/prompt', ...options });

/**
 * Download telemetry schema
 */
export const downloadTelemetrySchemaAsUser = <ThrowOnError extends boolean = true>(options: Options<DownloadTelemetrySchemaAsUserData, ThrowOnError>) => (options.client ?? client).get<DownloadTelemetrySchemaAsUserResponses, unknown, ThrowOnError>({ url: '/user/schema-telemetry/{id}/schema', ...options });

/**
 * Get telemetry row by ID
 */
export const getTelemetryRowByIdAsUser = <ThrowOnError extends boolean = true>(options: Options<GetTelemetryRowByIdAsUserData, ThrowOnError>) => (options.client ?? client).get<GetTelemetryRowByIdAsUserResponses, unknown, ThrowOnError>({ url: '/user/schema-telemetry/{id}', ...options });

/**
 * List schema telemetry
 */
export const listSchemaTelemetryAsUser = <ThrowOnError extends boolean = true>(options?: Options<ListSchemaTelemetryAsUserData, ThrowOnError>) => (options?.client ?? client).get<ListSchemaTelemetryAsUserResponses, unknown, ThrowOnError>({ url: '/user/schema-telemetry', ...options });

/**
 * Get quota forecasting summary
 */
export const getQuotaForecastingSummaryAsUser = <ThrowOnError extends boolean = true>(options?: Options<GetQuotaForecastingSummaryAsUserData, ThrowOnError>) => (options?.client ?? client).get<GetQuotaForecastingSummaryAsUserResponses, unknown, ThrowOnError>({ url: '/user/quota-forecasting/summary', ...options });

/**
 * List quota forecasting entries
 */
export const listQuotaForecastingEntriesAsUser = <ThrowOnError extends boolean = true>(options?: Options<ListQuotaForecastingEntriesAsUserData, ThrowOnError>) => (options?.client ?? client).get<ListQuotaForecastingEntriesAsUserResponses, unknown, ThrowOnError>({ url: '/user/quota-forecasting/entries', ...options });

/**
 * Get timing summary
 */
export const getTimingSummaryAsUser = <ThrowOnError extends boolean = true>(options?: Options<GetTimingSummaryAsUserData, ThrowOnError>) => (options?.client ?? client).get<GetTimingSummaryAsUserResponses, unknown, ThrowOnError>({ url: '/user/timings/summary', ...options });

/**
 * List timing entries
 */
export const listTimingEntriesAsUser = <ThrowOnError extends boolean = true>(options?: Options<ListTimingEntriesAsUserData, ThrowOnError>) => (options?.client ?? client).get<ListTimingEntriesAsUserResponses, unknown, ThrowOnError>({ url: '/user/timings/entries', ...options });

/**
 * Get usage summary
 */
export const getUsageSummaryAsUser = <ThrowOnError extends boolean = true>(options?: Options<GetUsageSummaryAsUserData, ThrowOnError>) => (options?.client ?? client).get<GetUsageSummaryAsUserResponses, unknown, ThrowOnError>({ url: '/user/usage/summary', ...options });

/**
 * List usage entries
 */
export const listUsageEntriesAsUser = <ThrowOnError extends boolean = true>(options?: Options<ListUsageEntriesAsUserData, ThrowOnError>) => (options?.client ?? client).get<ListUsageEntriesAsUserResponses, unknown, ThrowOnError>({ url: '/user/usage/entries', ...options });

/**
 * List default agent mode budgets
 */
export const listDefaultAgentModeBudgetsAsAdmin = <ThrowOnError extends boolean = true>(options?: Options<ListDefaultAgentModeBudgetsAsAdminData, ThrowOnError>) => (options?.client ?? client).get<ListDefaultAgentModeBudgetsAsAdminResponses, unknown, ThrowOnError>({ url: '/admin/agent-mode-budgets', ...options });

/**
 * Reseed agent mode budgets for organizations
 */
export const reseedAgentModeBudgetsForOrganizationsAsAdmin = <ThrowOnError extends boolean = true>(options?: Options<ReseedAgentModeBudgetsForOrganizationsAsAdminData, ThrowOnError>) => (options?.client ?? client).post<ReseedAgentModeBudgetsForOrganizationsAsAdminResponses, unknown, ThrowOnError>({
    url: '/admin/agent-mode-budgets/reseed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * List organization feature flag overrides
 */
export const listOrganizationFeatureFlagOverridesAsAdmin = <ThrowOnError extends boolean = true>(options?: Options<ListOrganizationFeatureFlagOverridesAsAdminData, ThrowOnError>) => (options?.client ?? client).get<ListOrganizationFeatureFlagOverridesAsAdminResponses, unknown, ThrowOnError>({ url: '/admin/feature-flags', ...options });

/**
 * Set organization feature flag override
 */
export const setOrganizationFeatureFlagOverrideAsAdmin = <ThrowOnError extends boolean = true>(options: Options<SetOrganizationFeatureFlagOverrideAsAdminData, ThrowOnError>) => (options.client ?? client).put<SetOrganizationFeatureFlagOverrideAsAdminResponses, unknown, ThrowOnError>({
    url: '/admin/feature-flags/{flag}/organizations/{organizationId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List enrolled sandbox host bindings
 */
export const listEnrolledSandboxHostBindingsAsAdmin = <ThrowOnError extends boolean = true>(options?: Options<ListEnrolledSandboxHostBindingsAsAdminData, ThrowOnError>) => (options?.client ?? client).get<ListEnrolledSandboxHostBindingsAsAdminResponses, unknown, ThrowOnError>({ url: '/admin/host-fencing', ...options });

/**
 * Enroll a sandbox host binding
 */
export const enrollASandboxHostBindingAsAdmin = <ThrowOnError extends boolean = true>(options?: Options<EnrollASandboxHostBindingAsAdminData, ThrowOnError>) => (options?.client ?? client).post<EnrollASandboxHostBindingAsAdminResponses, unknown, ThrowOnError>({
    url: '/admin/host-fencing/enroll',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Inspect a sandbox host binding and its fence targets
 */
export const inspectASandboxHostBindingAndItsFenceTargetsAsAdmin = <ThrowOnError extends boolean = true>(options: Options<InspectASandboxHostBindingAndItsFenceTargetsAsAdminData, ThrowOnError>) => (options.client ?? client).get<InspectASandboxHostBindingAndItsFenceTargetsAsAdminResponses, unknown, ThrowOnError>({ url: '/admin/host-fencing/{bindingId}', ...options });

/**
 * Attest that an enrolled sandbox host is permanently gone
 */
export const attestThatAnEnrolledSandboxHostIsPermanentlyGoneAsAdmin = <ThrowOnError extends boolean = true>(options: Options<AttestThatAnEnrolledSandboxHostIsPermanentlyGoneAsAdminData, ThrowOnError>) => (options.client ?? client).post<AttestThatAnEnrolledSandboxHostIsPermanentlyGoneAsAdminResponses, unknown, ThrowOnError>({
    url: '/admin/host-fencing/{bindingId}/attest',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List keystore entries
 */
export const listKeystoreEntriesAsAdmin = <ThrowOnError extends boolean = true>(options?: Options<ListKeystoreEntriesAsAdminData, ThrowOnError>) => (options?.client ?? client).get<ListKeystoreEntriesAsAdminResponses, unknown, ThrowOnError>({ url: '/admin/keystore', ...options });

/**
 * Create keystore entry
 */
export const createKeystoreEntryAsAdmin = <ThrowOnError extends boolean = true>(options?: Options<CreateKeystoreEntryAsAdminData, ThrowOnError>) => (options?.client ?? client).post<CreateKeystoreEntryAsAdminResponses, unknown, ThrowOnError>({
    url: '/admin/keystore',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Delete keystore entry
 */
export const deleteKeystoreEntryAsAdmin = <ThrowOnError extends boolean = true>(options: Options<DeleteKeystoreEntryAsAdminData, ThrowOnError>) => (options.client ?? client).delete<DeleteKeystoreEntryAsAdminResponses, unknown, ThrowOnError>({ url: '/admin/keystore/{entryId}', ...options });

/**
 * Assign keystore entry
 */
export const assignKeystoreEntryAsAdmin = <ThrowOnError extends boolean = true>(options: Options<AssignKeystoreEntryAsAdminData, ThrowOnError>) => (options.client ?? client).post<AssignKeystoreEntryAsAdminResponses, unknown, ThrowOnError>({
    url: '/admin/keystore/{entryId}/assign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unassign keystore entry
 */
export const unassignKeystoreEntryAsAdmin = <ThrowOnError extends boolean = true>(options: Options<UnassignKeystoreEntryAsAdminData, ThrowOnError>) => (options.client ?? client).post<UnassignKeystoreEntryAsAdminResponses, unknown, ThrowOnError>({ url: '/admin/keystore/{entryId}/unassign', ...options });

/**
 * Get keystore spending
 */
export const getKeystoreSpendingAsAdmin = <ThrowOnError extends boolean = true>(options?: Options<GetKeystoreSpendingAsAdminData, ThrowOnError>) => (options?.client ?? client).get<GetKeystoreSpendingAsAdminResponses, unknown, ThrowOnError>({ url: '/admin/keystore/spending', ...options });

/**
 * List organizations for admin
 */
export const listOrganizationsForAdminAsAdmin = <ThrowOnError extends boolean = true>(options?: Options<ListOrganizationsForAdminAsAdminData, ThrowOnError>) => (options?.client ?? client).get<ListOrganizationsForAdminAsAdminResponses, unknown, ThrowOnError>({ url: '/admin/organizations', ...options });

/**
 * Grant organization credits
 */
export const grantOrganizationCreditsAsAdmin = <ThrowOnError extends boolean = true>(options: Options<GrantOrganizationCreditsAsAdminData, ThrowOnError>) => (options.client ?? client).post<GrantOrganizationCreditsAsAdminResponses, unknown, ThrowOnError>({
    url: '/admin/organizations/{organizationId}/credits',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get admin overview
 */
export const getAdminOverviewAsAdmin = <ThrowOnError extends boolean = true>(options?: Options<GetAdminOverviewAsAdminData, ThrowOnError>) => (options?.client ?? client).get<GetAdminOverviewAsAdminResponses, unknown, ThrowOnError>({ url: '/admin/overview', ...options });

/**
 * List platform users
 */
export const listPlatformUsersAsAdmin = <ThrowOnError extends boolean = true>(options?: Options<ListPlatformUsersAsAdminData, ThrowOnError>) => (options?.client ?? client).get<ListPlatformUsersAsAdminResponses, unknown, ThrowOnError>({ url: '/admin/users', ...options });

/**
 * Invalidate all sessions for a user
 */
export const invalidateAllSessionsForAuserAsAdmin = <ThrowOnError extends boolean = true>(options: Options<InvalidateAllSessionsForAuserAsAdminData, ThrowOnError>) => (options.client ?? client).post<InvalidateAllSessionsForAuserAsAdminResponses, unknown, ThrowOnError>({ url: '/admin/users/{userId}/invalidate-sessions', ...options });

/**
 * List archived Teams channels
 */
export const listArchivedTeamsChannelsAsAdmin = <ThrowOnError extends boolean = true>(options: Options<ListArchivedTeamsChannelsAsAdminData, ThrowOnError>) => (options.client ?? client).get<ListArchivedTeamsChannelsAsAdminResponses, unknown, ThrowOnError>({ url: '/admin/teams/archived-channels', ...options });

/**
 * List Teams outbox messages
 */
export const listTeamsOutboxMessagesAsAdmin = <ThrowOnError extends boolean = true>(options: Options<ListTeamsOutboxMessagesAsAdminData, ThrowOnError>) => (options.client ?? client).get<ListTeamsOutboxMessagesAsAdminResponses, unknown, ThrowOnError>({ url: '/admin/teams/outbox', ...options });

/**
 * Retry Teams outbox message
 */
export const retryTeamsOutboxMessageAsAdmin = <ThrowOnError extends boolean = true>(options: Options<RetryTeamsOutboxMessageAsAdminData, ThrowOnError>) => (options.client ?? client).post<RetryTeamsOutboxMessageAsAdminResponses, unknown, ThrowOnError>({
    url: '/admin/teams/outbox/{id}/retry',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Skip Teams outbox message
 */
export const skipTeamsOutboxMessageAsAdmin = <ThrowOnError extends boolean = true>(options: Options<SkipTeamsOutboxMessageAsAdminData, ThrowOnError>) => (options.client ?? client).post<SkipTeamsOutboxMessageAsAdminResponses, unknown, ThrowOnError>({
    url: '/admin/teams/outbox/{id}/skip',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel Teams outbox message
 */
export const cancelTeamsOutboxMessageAsAdmin = <ThrowOnError extends boolean = true>(options: Options<CancelTeamsOutboxMessageAsAdminData, ThrowOnError>) => (options.client ?? client).post<CancelTeamsOutboxMessageAsAdminResponses, unknown, ThrowOnError>({
    url: '/admin/teams/outbox/{id}/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Teams admin setup
 */
export const getTeamsAdminSetupAsAdmin = <ThrowOnError extends boolean = true>(options: Options<GetTeamsAdminSetupAsAdminData, ThrowOnError>) => (options.client ?? client).get<GetTeamsAdminSetupAsAdminResponses, unknown, ThrowOnError>({ url: '/admin/teams/setup', ...options });

/**
 * Save Teams admin setup
 */
export const saveTeamsAdminSetupAsAdmin = <ThrowOnError extends boolean = true>(options?: Options<SaveTeamsAdminSetupAsAdminData, ThrowOnError>) => (options?.client ?? client).post<SaveTeamsAdminSetupAsAdminResponses, unknown, ThrowOnError>({
    url: '/admin/teams/setup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Validate Teams bot credentials
 */
export const validateTeamsBotCredentialsAsAdmin = <ThrowOnError extends boolean = true>(options?: Options<ValidateTeamsBotCredentialsAsAdminData, ThrowOnError>) => (options?.client ?? client).post<ValidateTeamsBotCredentialsAsAdminResponses, unknown, ThrowOnError>({
    url: '/admin/teams/validate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Handle Stripe webhook
 */
export const handleStripeWebhookAsWebhook = <ThrowOnError extends boolean = true>(options?: Options<HandleStripeWebhookAsWebhookData, ThrowOnError>) => (options?.client ?? client).post<HandleStripeWebhookAsWebhookResponses, unknown, ThrowOnError>({ url: '/webhook/stripe', ...options });
